import React from 'react';
import {AbstractReactFactory} from '@projectstorm/react-canvas-core';

import {AbstractNodeModel, AbstractNodeWidget} from "./AbstractNode";
import {withTranslation} from "react-i18next";


class ChooseLanguageNodeWidget_ extends AbstractNodeWidget {
    constructor(props) {
        super(props);

        this.type = 'choose-language-node';
    }

    getHeader() {
        const options = this.props.node.options;
        return <>
            <i className="pe-7s-global"> </i> {options.step.name || this.props.t('pages.main.flow_builder.node.choose_language.name', 'Language selection')}
        </>;
    }
}

export const ChooseLanguageNodeWidget = withTranslation()(ChooseLanguageNodeWidget_);

export class ChooseLanguageNodeModel extends AbstractNodeModel {
    constructor(options = {}) {
        super({
            ...options,
            type: 'choose-language-node'
        });
    }
}


export class ChooseLanguageNodeFactory extends AbstractReactFactory {
    constructor() {
        super('choose-language-node');
    }

    generateModel(event) {
        return new ChooseLanguageNodeModel();
    }

    generateReactWidget(event) {
        return <ChooseLanguageNodeWidget engine={this.engine} node={event.model}/>;
    }
}
